<template>
  <div class="regalos-section">
    <!-- Flores decorativas -->
    <img ref="florArriba" src="@/assets/florunica.png" alt="Flor decorativa" class="flor flor-arriba" />

    <!-- Contenido -->
    <div class="card-contenido">
      <h2 ref="titulo" class="titulo-regalo">Mesa de Regalo</h2>
      <p ref="mensaje" class="mensaje-regalo">
        Lo mejor para mí sería compartir este día contigo, cualquier otro detalle será muy bien recibido con mucho cariño y agradecimiento, que Dios les recompense con muchas bendiciones.
      </p>
      <img ref="icono" src="@/assets/sonrte-dor.png" alt="icono sobre" class="icono-sobre" />
      <p ref="gracias" class="gracias-texto">¡Gracias!</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import gsap from 'gsap';

export default {
  name: 'RegalosSection',
  setup() {
    const florArriba = ref(null);
    const titulo = ref(null);
    const mensaje = ref(null);
    const icono = ref(null);
    const gracias = ref(null);

    const animar = () => {
      const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

      tl.fromTo(florArriba.value, { y: -50, opacity: 0 }, { y: 0, opacity: 1, duration: 1 })
        .fromTo(titulo.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8 }, '-=0.6')
        .fromTo(mensaje.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, '-=0.5')
        .fromTo(icono.value, { scale: 0.5, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.8 }, '-=0.4')
        .fromTo(gracias.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.3');
    };

    onMounted(() => {
      nextTick(() => {
        const observer = new IntersectionObserver(([entry], obs) => {
          if (entry.isIntersecting) {
            animar();
            obs.unobserve(entry.target);
          }
        }, { threshold: 0.2 });

        observer.observe(titulo.value);
      });
    });

    return {
      florArriba,
      titulo,
      mensaje,
      icono,
      gracias
    };
  }
};
</script>

<style scoped>
.regalos-section {
  background-image: linear-gradient(to bottom, #ffffff, #f4f3f3);
  background-size: cover;
  padding: 60px 20px;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.card-contenido {
  max-width: 600px;
  margin: auto;
  background: transparent;
  padding: 30px 20px;
  border-radius: 15px;
}

.titulo-regalo {
 font-family: 'britishgruesa', cursive;
  font-size: 56px;
  color: #363636;  
  margin-bottom: 20px;
  opacity: 0;
}

.mensaje-regalo {
  font-family: 'quote', sans-serif;
  font-size: 16px;
  color: #403d3d;
  margin-bottom: 25px;
  opacity: 0;
}

.icono-sobre {
  width: 120px;
  height: auto;
  margin-bottom: 15px;
  opacity: 0;
}

.gracias-texto {
  font-family: 'padres', serif;
  font-size: 34px;
  font-weight: 500;
  color: #1e1d1d;
  opacity: 0;
}

/* Flores */
.flor {
  position: absolute;
  width: 180px;
  opacity: 0;
  pointer-events: none;
}

.flor-arriba {
  top: 0;
  left: 50%;
  transform: translateX(-50%) rotate(-8deg);
}

.flor-abajo {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) rotate(8deg);
}
</style>
